import { Field, Formik, isEmptyArray } from "formik";
import React, { useContext, useState, useEffect, useRef } from "react";
import { get, isEmpty, isNull } from "lodash";
import {
  Form,
  Button,
  Tab,
  Row,
  ListGroup,
  InputGroup,
  Image,
} from "react-bootstrap";
import {
  DatePicker,
  SearchableList,
  FieldDropSide,
  SliderPanel,
  FormControlSearch,
  ManageCommunicationLayout,
  FieldInput,
  CommunicationCard,
  Dropside,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageCommunicationFormNames,
  formFields,
  MANAGE_COMMUNICATION_ROUTES,
  getPathWithParam,
  errors,
  FLOW_TYPES,
  toMultiSelectValueById,
  clearFieldValues,
  CategoryOptions,
} from "../../../utils";
import { Link } from "react-router-dom";
import {
  manageCommunicationStore,
  setManageCommunicationFullPageData,
} from "../../../contexts";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import "../../../styles/containers/CommunicationContainer.scss";
import {
  getEventsList,
  getPlanGroups,
  getPlanList,
  postCommunicationCardView,
} from "../../../services";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import FiltersDropDown from "../../Mapper/LoadDefHomeContainer/FiltersDropDown";
const initialValues = { search: "", categorizedLevel: 0, type: 0 };
const allOption = { label: "All", value: 0 };
const categorizedOptions = [
  allOption,
  { label: "Global", value: 1 },
  { label: "Plan Group", value: 3 },
  { label: "Plan Level", value: 2 },
];
const typeOptions = [
  allOption,
  { label: "Event", value: 2 },
  { label: "Schedule", value: 1 },
];
const CommunicationContainer = (props) => {
  const { setFieldValues } = props;
  const { state, dispatch } = useContext(manageCommunicationStore);
  const { flow } = useRouterParams();
  const formName = manageCommunicationFormNames.PLAN_LEVEL_COMMUNICATION;
  const fields = formFields[formName];
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const communicationMode = useRef(0);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const append = useRef(false);
  const numberOfRecordsToFetch = 20;
  const defaultSeachRequest = {
    search: "",
    from: 0,
    offset: numberOfRecordsToFetch,
  };
  const [request, setRequest] = useState(defaultSeachRequest);
  const [clearSearchVal, setClearSearchVal] = useState(false);
  //const [filterdata, setFilterData] = useState(data);
  const cardDataAll = (val) => {
    communicationMode.current = val;
    if (val == 1) {
      var carddata = data.filter((x) => x.channel == "1" && x.channel != "0");
      setFilteredData(carddata);
    } else if (val == 2) {
      var carddata = data.filter((x) => x.channel == "2" && x.channel != "0");
      setFilteredData(carddata);
    } else {
      var carddata = data.filter((x) => x.channel != 0);
      setFilteredData(carddata);
    }
  };

  const [index, setIndex] = useState(0);
  const [eventsList, setEventsList] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [selectedPlanGroup, setSelectedPlanGroup] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [planGroup, setPlanGroup] = useState([]);
  const [loading, setLoading] = useState(false);
  let source = axios.CancelToken.source(); // this is used to cancel the api call in the useEffect cleanup

  const onNewCommunicationClick = () => {
    dispatch(
      setManageCommunicationFullPageData({
        entryFromNewCommunication: true,
      })
    );
  };

  const buttons = [
    {
      onClick: onNewCommunicationClick,
      link: getPathWithParam({
        path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO,
        pathParam: [FLOW_TYPES.ADD],
      }),
      label: "New Communication",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
  ];
  useEffect(() => {
    getPlanList(0).then((response) =>
      setPlanList(
        response.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        })
      )
    );

    getPlanGroups({ from: 0, offset: 0, searchInput: "" }).then((response) => {
      response.sort(function (r1, r2) {
        const nameA = r1.name.toUpperCase();
        const nameB = r2.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setPlanGroup(
        response.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        })
      );
    });
  }, []);

  useDeepEffect(() => {
    setLoading(true);
    getEventsList().then((response) =>
      setEventsList(
        response.map((item) => {
          return {
            label: item.name,
            value: item.id,
            eventCategory: item.eventCategory,
            metaData: item.metaData,
          };
        })
      )
    );
    getCommunicationCardView(request);

    return () => {
      source.cancel("cancelled");
    };
  }, [request]);

  const getCommunicationCardView = (request) => {
    setLoading(true);
    postCommunicationCardView({ search: "", ...request }, source.token)
      .then((response) => {
        if (response?.length < numberOfRecordsToFetch)
          setStopInfiniteScroll(true);
        if (append.current) {
          setData((prev) => [...prev, ...response]);
          setFilteredData((prev) => [...prev, ...response]);
        } else {
          setData(response.filter((x) => x.channel != 0));
          setFilteredData(response.filter((x) => x.channel != 0));
        }
        setLoading(false);
      })
      .catch((ex) => {
        setLoading(false);
      });
  };

  const onFormSubmit = (values) => {
    values.communicationMode = communicationMode.current;
    append.current = false;
    setStopInfiniteScroll(false);
    setRequest({
      ...values,
      from: 0,
      offset: numberOfRecordsToFetch,
    });
    setClearSearchVal(false);
  };

  const handleClick = (input, data) => {
    cardDataAll(input);
    setIndex(input);
  };

  const options = [
    {
      label: "All",
      index: 0,
    },
    {
      label: "E-Mail",
      index: 1,
    },
  ];

  return (
    <ManageCommunicationLayout
      pageName="Manage Communication"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
      overflow="overflow-hidden"
    >
      <Formik
        initialValues={{
          ...initialValues,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          ...rest
        }) => {
          return (
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <div
                className={`${
                  values[fields.categorizedLevel] === 2 ||
                  values[fields.categorizedLevel] === 3
                    ? "CommunicationContainer"
                    : "CommunicationContainer-var"
                }`}
              >
                <div className="header1 flex-wrap1">
                  <div>
                    <div className="ft-12 ftwt-500 lh-19 mb-5 dark">
                      Search
                      <span
                        style={{
                          padding: "0.05rem 0.3rem",
                          fontsize: "0.65rem",
                          color: "#828282",
                        }}
                      >
                        (Optional)
                      </span>
                    </div>
                    <Form>
                      <div style={{ height: "53px" }}>
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text className="plan-search-button">
                              <Image
                                src="/assets/icons/svg/search.svg"
                                width="14px"
                              />
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControlSearch
                            size="smd"
                            type="text"
                            label="Search"
                            //className="plan-search-box pad-left-search"
                            placeholder="communication"
                            screen = "communication"
                            clearSearchValue={clearSearchVal}
                            onChange={(e) => {
                              setFieldValue(fields.search, e.target.value);
                              setClearSearchVal(false);
                            }}
                          />
                        </InputGroup>
                      </div>
                    </Form>
                  </div>
                  <div
                    className={`${
                      values[fields.categorizedLevel] === 2 ||
                      values[fields.categorizedLevel] === 3
                        ? "categorized-level-var1"
                        : "categorized-level-var1"
                    } communication-field-width-flair closeIcon`}
                  >
                    <Field
                      isRequired
                      label="Categorized Level"
                      name={fields.categorizedLevel}
                      value={values[fields.categorizedLevel]}
                      direction="bottom"
                      options={categorizedOptions}
                      placeholder="Categorized Level"
                      size="xs"
                      popupContent={
                        <SearchableList
                          label="Select Level"
                          options={categorizedOptions}
                          onSelect={(value, ind) => {
                            // setValues({
                            //   ...values,
                            //   [fields.categorisedLevel]: value,
                            // });
                            setFieldValue(fields.categorizedLevel, value);
                            setFieldValue(fields.planId, null);
                            setFieldValue(fields.planGroupId, null);
                            setSelectedPlans([]);
                            setSelectedPlanGroup([]);
                          }}
                          selectedValue={values[fields.categorizedLevel]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  {values[fields.categorizedLevel] === 3 && (
                    <div className="mb-3 categorized-level-var1 communication-field-width-flair">
                      <div className="ft-12 ftwt-500 dark plan-group-name-field">
                        Plan Group Name
                      </div>
                      <div style={{ width: "140px" }}>
                        <Dropside
                          size="xs"
                          direction="bottom"
                          name={fields.planGroupId}
                          label="Plan Group Name"
                          placeholder={"All"}
                          options={planGroup}
                          isMultiSelect
                          isPlanName={true}
                          isRequired
                          value={toMultiSelectValueById(
                            selectedPlanGroup,
                            planGroup
                          )}
                          popupContent={
                            <MultiSelectDropdown
                              label="Select Group"
                              width="305px"
                              height="250px"
                              //position="absolute"
                              placeholder="Search"
                              maxHeight="300px"
                              options={planGroup}
                              onSelect={(value) => {
                                setFieldValue(fields.planGroupId, value);
                                setSelectedPlanGroup(value);
                              }}
                              name={"planGroupStatus"}
                              value={selectedPlanGroup}
                              isTypeAhead={true}
                              isClear={true}
                              isManagePage={true}
                            />
                          }
                        />
                      </div>
                    </div>
                  )}
                  {values[fields.categorizedLevel] === 2 && (
                    <div className="mb-3 mb-3 categorized-level-var1 communication-field-width-flair">
                      <div className="ft-12 ftwt-500 dark plan-group-name-field">
                        Plan Name
                      </div>
                      <div style={{ width: "140px" }}>
                        <Dropside
                          size="xs"
                          direction="bottom"
                          name={fields.planId}
                          label="Plan Name"
                          placeholder={"All"}
                          options={planList}
                          isMultiSelect
                          isRequired
                          isPlanName={true}
                          value={toMultiSelectValueById(
                            selectedPlans,
                            planList
                          )}
                          popupContent={
                            <MultiSelectDropdown
                              label="Select plan"
                              width="305px"
                              placeholder="Search"
                              height="250px"
                              maxHeight="300px"
                              options={planList}
                              onSelect={(value) => {
                                setFieldValue(fields.planId, value);
                                setSelectedPlans(value);
                              }}
                              name={"planStatus"}
                              value={selectedPlans}
                              isTypeAhead={true}
                              isClear={true}
                              isManagePage={true}
                            />
                          }
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className={`${
                      values[fields.categorizedLevel] === 2 ||
                      values[fields.categorizedLevel] === 3
                        ? "event-category-var1 event-category-search"
                        : "event-category-var1 event-category-search"
                    } communication-field-width-flair closeIcon popUpWidth`}
                  >
                    <Field
                      label="Event Category"
                      name={fields.eventCategory}
                      value={values[fields.eventCategory]}
                      direction="bottom"
                      placeholder="Event Category"
                      size="sm"
                      options={CategoryOptions}
                      popupContent={
                        <SearchableList
                          label="Select event category"
                          height="150px"
                          options={CategoryOptions}
                          onSelect={(value) => {
                            setValues({
                              ...values,
                              [fields.eventCategory]: value,
                            });
                            setFieldValue(fields.eventName, null);
                          }}
                          selectedValue={values[fields.eventCategory]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div
                    className={`${
                      values[fields.categorizedLevel] === 2 ||
                      values[fields.categorizedLevel] === 3
                        ? "event-name-var1"
                        : "event-name-var1"
                    } communication-field-width-flair closeIcon`}
                  >
                    <Field
                      label="Event Name"
                      name={fields.eventName}
                      value={values[fields.eventName]}
                      direction="bottom"
                      placeholder="Event Name"
                      size="sm"
                      options={eventsList.filter(
                        (x) => x.eventCategory == values.eventCategory
                      )}
                      popupContent={
                        <SearchableList
                          label="Select Event Name"
                          width="300px"
                          height="200px"
                          options={eventsList.filter(
                            (x) => x.eventCategory == values.eventCategory
                          )}
                          onSelect={(value) =>
                            setValues({
                              ...values,
                              [fields.eventName]: value,
                            })
                          }
                          selectedValue={values[fields.eventName]}
                        />
                      }
                      component={FieldDropSide}
                    />
                    {/* <div
                      className="event-name-width"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "7px",
                      }}
                    >
                      <div
                        style={{
                          marginBottom: "5px",
                          fontSize: "12px",
                          color: "#000000",
                          fontWeight: "500",
                          lineHeight: "1.23",
                        }}
                      >
                        Event Name
                      </div>
                      <div style={{ width: "170px" }}>
                        <Dropside
                          leftOffset={120}
                          // size="xs"
                          direction="bottom"
                          name={fields.eventName}
                          isRequired
                          label="Event Name"
                          placeholder="Event Name"
                          options={eventsList.filter(
                            (x) => x.eventCategory == values.eventCategory
                          )}
                          isMultiSelect
                          value={toMultiSelectValueById(
                            values[fields.eventName],
                            eventsList.filter(
                              (x) => x.eventCategory == values.eventCategory
                            )
                          )}
                          popupContent={
                            <MultiSelectDropdown
                              label="Select Event Name"
                              hideSelectedOptions="FALSE"
                              width="305px"
                              placeholder="Search"
                              height="190px"
                              maxHeight="200px"
                              options={eventsList.filter(
                                (x) => x.eventCategory == values.eventCategory
                              )}
                              onSelect={(value) => {
                                setFieldValue(fields.eventName, value);
                                //setSelectedPlans(value);
                              }}
                              name={"eventName"}
                              value={values[fields.eventName]}
                              isTypeAhead={true}
                              isClear={true}
                            />
                          }
                        />
                      </div>
                    </div> */}
                  </div>

                  {/* <div>
                    <Field
                      isRequired
                      label="Type"
                      name={fields.type}
                      value={values[fields.type]}
                      direction="bottom"
                      options={typeOptions}
                      placeholder="-Select-"
                      size="sm"
                      popupContent={
                        <SearchableList
                          label="Select Type"
                          options={typeOptions}
                          onSelect={(value) =>
                            // setValues({ ...values, [fields.type]: value })
                            setFieldValue(fields.type, value)
                          }
                          selectedValue={values[fields.type]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div> */}
                  <div
                    style={{ marginLeft: "8px" }}
                    className={`d-flex ${
                      values[fields.categorizedLevel] === 2 ||
                      values[fields.categorizedLevel] === 3
                        ? "Search-Button-var1"
                        : "Search-Button-var1"
                    } mb-3`}
                  >
                    <div className="element pr-2">
                      <Button
                        variant="secondary"
                        onClick={() => {
                          setClearSearchVal(true);
                          setFieldValue("search", null);
                          setFieldValue(fields.categorizedLevel, 0);
                          setFieldValue(fields.eventCategory, null);
                          setFieldValue(fields.eventName, null);
                          getCommunicationCardView(defaultSeachRequest);
                        }}
                        className=" padding-search-clear-filter"
                      >
                        Clear
                      </Button>
                    </div>
                    <div
                      className="element"
                      style={{
                        marginLeft: "8px",
                      }}
                    >
                      <Button
                        type="submit"
                        variant="secondary"
                        className=" padding-search-clear-filter"
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <hr className="CommunicationTo-horizontal mb-4"></hr>
      <LoaderWrapper
        isLoading={loading}
        // style={{ all: "initial" }}
        className="noScrollBar"
      >
        {/* <div className="pillInputButton d-flex mb-10p"> */}
        {/* {options?.map((_) => {
            return (
              <PillComponent
                label={_?.label}
                handleClick={handleClick}
                inputForClick={_?.index}
                className={
                  _?.index == index ? "filteredActiveButton mr-10p" : "mr-10p"
                }
                isInput={false}
              />
            );
          })} */}
        {/* </div> */}

        {filteredData.length > 0 ? (
          <div
            className="ft-14 lh-21"
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "25px",
            }}
          >
            <p>Recently added/Modified</p>
            <p style={{ marginRight: "15px" }}>
              {filteredData.length} Communications found
            </p>
          </div>
        ) : null}

        <div
          className="bodyContent1"
          style={{ height: "70%", overflowY: "scroll", paddingBottom: "70px" }}
        >
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              append.current = true;
              setRequest((request) => ({
                ...request,
                from: filteredData?.length,
              }));
            }}
            hasMore={!stopInfiniteScroll}
            initialLoad={false}
            threshold={100}
            useWindow={false}
            // loader={
            //   <div className="loader" key={0}>
            //     Loading ...
            //   </div>
            // }
          >
            {filteredData.length > 0 ? (
              <>
                <div className="d-flex p-2 ml-3">
                  <div className="font-weight-bold" style={{ width: "36%" }}>
                    Communication Details
                  </div>
                  <div className="font-weight-bold" style={{ width: "39%" }}>
                    Event Details
                  </div>
                  <div className="font-weight-bold" style={{ width: "25%" }}>
                    Level
                  </div>
                  <div className="font-weight-bold" style={{ width: "19%" }}>
                    Layout
                  </div>
                </div>
                {filteredData.map((x) => {
                  return (
                    <Link
                      to={getPathWithParam({
                        path: `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}`,
                        pathParam: [FLOW_TYPES.EDIT, x.id],
                      })}
                      style={{ textDecoration: "none" }}
                    >
                      <CommunicationCard
                        eventsList={eventsList ? eventsList : null}
                        data={x}
                      />
                    </Link>
                  );
                })}
              </>
            ) : (
              <span
                style={{
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#333333",
                  display: "block",
                }}
              >
                No Records Found
              </span>
            )}
          </InfiniteScroll>
        </div>
      </LoaderWrapper>
    </ManageCommunicationLayout>
  );
};

export default CommunicationContainer;
